var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"bg",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"posterImg"},[_c('img',{attrs:{"src":_vm.posterImg,"alt":""}})]),_vm._v(" "),_c('canvas',{attrs:{"id":"post","width":"527","height":"882"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54bfe5cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/poster.vue
// module id = null
// module chunks = 